export default {
  title: 'テストタイトル',
};
